// This file contains the list of shirts and their properties
// ----------------------------------------------------------------------------
// Product properties:
// - id: uniqueue if of the product
// - brandName: brandName of the product
// - productName: name of the product
// - originalPrice: original price of the product
// - discountPercent: discount on the product
// - images: list of product images
// - postedAt: id of the product
// - numberOfReviews: number of reviews on the product
// - rating: rating of the product
// - colour: List of colours of the product 
// - gender: gender to which the shirt belong

export const products = [
    {
        id: "828019",
        brandName: "LEVIS",
        productName: "Slim Fit Printed Casual Shirt",
        price: 2639,
        originalPrice: 3299,
        discountPercent: 20,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13358668/2021/2/8/fea23466-ad54-49ec-aaba-bab98fb1a9e61612774385309-Levis-Men-Shirts-9061612774383873-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13358668/2021/2/8/85888e1f-bab2-417c-827d-b73dc9c3b3c71612774385291-Levis-Men-Shirts-9061612774383873-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13358668/2021/2/8/344b7421-f638-43e9-aa34-15e553342fb01612774385274-Levis-Men-Shirts-9061612774383873-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13358668/2021/2/8/fbbf445a-64f2-4bb0-9e39-55a59f9a8c8b1612774385256-Levis-Men-Shirts-9061612774383873-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13358668/2021/2/8/1a53a156-e950-44ce-8e11-48df7f6590921612774385239-Levis-Men-Shirts-9061612774383873-5.jpg",
        ],
        postedAt: 1431787516,
        numberOfReviews: 5400,
        rating: 4.1,
        color: ["WHITE", "BLUE"],
        gender: "MALE",
    },
    {
        id: "82019",
        brandName: "LEVIS",
        productName: "Slim Fit Checked Shirt",
        price: 1599,
        originalPrice: 1999,
        discountPercent: 20,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13170746/2021/1/5/52848358-0cbd-44e4-9749-88e9fc8c5ea71609828325310-Levis-Men-Shirts-8831609828323812-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13170746/2021/1/5/a4505bb0-612c-4ba7-a389-ba7a1e282e041609828325264-Levis-Men-Shirts-8831609828323812-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13170746/2021/1/5/352b4729-7031-4bad-be46-7ef8222e61a41609828325210-Levis-Men-Shirts-8831609828323812-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13170746/2021/1/5/0085af9d-20b0-48a2-8036-74f43c0fe8871609828325161-Levis-Men-Shirts-8831609828323812-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13170746/2021/1/5/4f115860-c914-4402-8015-5f7eb9ca49fa1609828325115-Levis-Men-Shirts-8831609828323812-5.jpg",
        ],
        postedAt: 1584888316,
        numberOfReviews: 2550,
        rating: 4.5,
        color: ["GREEN", "BLUE"],
        gender: "MALE",
    },
    {
        id: "111354",
        brandName: "LEVIS",
        productName: "Regular Fit Linen Solid Shirt",
        price: 2639,
        originalPrice: 3299,
        discountPercent: 20,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12365690/2021/1/20/73a9a06b-4d24-4cd3-a958-10e4cceea44b1611122727200-Levis-Men-Shirts-3321611122725361-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12365690/2021/1/20/6b133902-ff35-47db-93f7-1b1e335c77041611122727181-Levis-Men-Shirts-3321611122725361-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12365690/2021/1/20/50184889-c843-4dec-92a3-3ebaa799565e1611122727163-Levis-Men-Shirts-3321611122725361-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12365690/2021/1/20/35dbe0e7-0e5a-4f2d-adcf-f8a10db0eee41611122727140-Levis-Men-Shirts-3321611122725361-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12365690/2021/1/20/44d48ef1-4b88-4e75-8732-82e28e9087af1611122727119-Levis-Men-Shirts-3321611122725361-5.jpg",
        ],
        postedAt: 1326740656,
        numberOfReviews: 600,
        rating: 4.2,
        color: ["WHITE"],
        gender: "MALE",
    },
    {
        id: "723891",
        brandName: "ROADSTER",
        productName: "Checked Casual Shirt",
        price: 879,
        originalPrice: 1599,
        discountPercent: 45,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/6849350/2019/2/4/637626cc-565d-4322-98ed-2674cfa4a4281549278244906-Roadster-Men-Blue-Regular-Fit-Checked-Casual-Shirt-378154927-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/6849350/2019/2/4/9d4ff7c7-549f-4b8f-9bea-f254c3c631861549278244885-Roadster-Men-Blue-Regular-Fit-Checked-Casual-Shirt-378154927-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/6849350/2019/2/4/41772698-8748-466f-a091-6de23005bbad1549278244863-Roadster-Men-Blue-Regular-Fit-Checked-Casual-Shirt-378154927-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/6849350/2019/2/4/20d86166-4420-43f2-baad-c397fb8712be1549278244843-Roadster-Men-Blue-Regular-Fit-Checked-Casual-Shirt-378154927-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/6849350/2019/2/4/fc961fe1-19bd-4b43-a64a-4cc761f1f4d81549278244822-Roadster-Men-Blue-Regular-Fit-Checked-Casual-Shirt-378154927-5.jpg",
        ],
        postedAt: 1312257136,
        numberOfReviews: 4690,
        rating: 4.0,
        color: ["BLUE"],
        gender: "MALE",
    },
    {
        id: "412562",
        brandName: "ROADSTER",
        productName: "Checked Casual Shirt",
        price: 909,
        originalPrice: 1299,
        discountPercent: 30,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12947450/2021/1/27/3a52d6b9-04c1-4188-9ddb-473484a365081611724552932-Roadster-Men-Shirts-4521611724551117-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12947450/2021/1/27/b0494c20-73e7-49d4-8714-ded9e49bc6751611724552909-Roadster-Men-Shirts-4521611724551117-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12947450/2021/1/27/0ec30fab-ebb0-48f0-aebc-597ea00822f31611724552887-Roadster-Men-Shirts-4521611724551117-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12947450/2021/1/27/1dbef28e-6801-4ced-91d6-4913b7b3fdc81611724552866-Roadster-Men-Shirts-4521611724551117-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12947450/2021/1/27/7d643463-327a-4e4e-9135-1d701a9b2c831611724552844-Roadster-Men-Shirts-4521611724551117-5.jpg",
        ],
        postedAt: 1479014104,
        numberOfReviews: 30,
        rating: 3.9,
        color: ["YELLOW", "BROWN"],
        gender: "MALE",
    },
    {
        id: "156780",
        brandName: "JACK & JONES",
        productName: "Checked Casual Shirt",
        price: 1499,
        originalPrice: 2999,
        discountPercent: 50,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11207384/2020/3/18/905a59cc-6bb9-4edb-9d94-4497840612da1584524005223-Jack--Jones-Men-Shirts-7541584524003798-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11207384/2020/3/18/89aae892-f8df-49dd-8428-4816fc0d4efd1584524005179-Jack--Jones-Men-Shirts-7541584524003798-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11207384/2020/3/18/e123d028-9d6d-44b9-8837-515bb4f9be801584524005130-Jack--Jones-Men-Shirts-7541584524003798-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11207384/2020/3/18/e79ef476-813a-4b87-87fe-39f787c6197a1584524005075-Jack--Jones-Men-Shirts-7541584524003798-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11207384/2020/3/18/ce209ff5-5201-44e3-9b29-64b3555aaddf1584524005025-Jack--Jones-Men-Shirts-7541584524003798-5.jpg",
        ],
        postedAt: 1513631715,
        numberOfReviews: 1200,
        rating: 4.4,
        color: ["GREEN", "WHITE"],
        gender: "MALE",
    },
    {
        id: "121329",
        brandName: "MAST & HARBOUR",
        productName: "Checked Casual Shirt",
        price: 1099,
        originalPrice: 1999,
        discountPercent: 45,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2042528/2017/9/28/11506599316866-Mast--Harbour-Men-Red--Blue-Regular-Fit-Checked-Casual-Shirt-7991506599316924-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2042528/2017/9/28/11506599316846-Mast--Harbour-Men-Red--Blue-Regular-Fit-Checked-Casual-Shirt-7991506599316924-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2042528/2017/9/28/11506599316823-Mast--Harbour-Men-Red--Blue-Regular-Fit-Checked-Casual-Shirt-7991506599316924-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2042528/2017/9/28/11506599316798-Mast--Harbour-Men-Red--Blue-Regular-Fit-Checked-Casual-Shirt-7991506599316924-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2042528/2017/9/28/11506599316667-Mast--Harbour-Men-Red--Blue-Regular-Fit-Checked-Casual-Shirt-7991506599316924-5.jpg",
        ],
        postedAt: 1544940919,
        numberOfReviews: 621,
        rating: 4.6,
        color: ["RED", "BLUE"],
        gender: "MALE",
    },
    {
        id: "157167",
        brandName: "HERE & NOW",
        productName: "Regular Fit Solid Casual Shirt",
        price: 599,
        originalPrice: 1499,
        discountPercent: 60,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/7425041/2020/1/17/7061d858-c913-449a-9e46-6a67694379961579260299274-HERENOW-Men-Mustard-Regular-Fit-Solid-Casual-Shirt-102157926-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/7425041/2020/1/17/b7dd869a-ea3a-4b44-9536-539fb8d5d3371579260299227-HERENOW-Men-Mustard-Regular-Fit-Solid-Casual-Shirt-102157926-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/7425041/2020/1/17/a05b339f-10a3-47ed-8646-f8fb0c327f931579260299164-HERENOW-Men-Mustard-Regular-Fit-Solid-Casual-Shirt-102157926-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/7425041/2020/1/17/c62c64af-ad77-4adf-8bee-0ae2a9476bfe1579260299113-HERENOW-Men-Mustard-Regular-Fit-Solid-Casual-Shirt-102157926-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/7425041/2020/1/17/4cccae29-4de1-4f8d-b989-c67b81e6f7d71579260299065-HERENOW-Men-Mustard-Regular-Fit-Solid-Casual-Shirt-102157926-5.jpg",
        ],
        postedAt: 1349661604,
        numberOfReviews: 7000,
        rating: 3.9,
        color: ["YELLOW"],
        gender: "MALE",
    },
    {
        id: "180820",
        brandName: "WROGN",
        productName: "Slim Fit Solid Casual Shirt",
        price: 1259,
        originalPrice: 2099,
        discountPercent: 40,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1758578/2017/5/12/11494569522819-WROGN-Men-Shirts-8521494569522516-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1758578/2017/5/12/11494569522794-WROGN-Men-Shirts-8521494569522516-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1758578/2017/5/12/11494569522769-WROGN-Men-Shirts-8521494569522516-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1758578/2017/5/12/11494569522745-WROGN-Men-Shirts-8521494569522516-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/1758578/2017/5/12/11494569522717-WROGN-Men-Shirts-8521494569522516-5.jpg",
        ],
        postedAt: 1264271400,
        numberOfReviews: 360,
        rating: 4.2,
        color: ["GREEN"],
        gender: "MALE",
    },
    {
        id: "108974",
        brandName: "HANCOCK",
        productName: "Regular Fit Floral Shirt",
        price: 1379,
        originalPrice: 2299,
        discountPercent: 40,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13320818/2021/1/8/623cd387-b2b7-45c0-a539-fb50fe44c2751610105263406-Hancock-Men-Shirts-9181610105261837-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13320818/2021/1/8/d947f2be-aa02-4c4e-96ac-4e9294dbee931610105263349-Hancock-Men-Shirts-9181610105261837-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13320818/2021/1/8/6376f3f8-7540-47dd-9a6e-0477b38e85fd1610105263280-Hancock-Men-Shirts-9181610105261837-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13320818/2021/1/8/9113d22d-eb4a-4c2a-8528-c8158dea10371610105263222-Hancock-Men-Shirts-9181610105261837-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13320818/2021/1/8/def93238-c580-47f1-b25f-7084502477ad1610105263168-Hancock-Men-Shirts-9181610105261837-5.jpg",
        ],
        postedAt: 1604237061,
        numberOfReviews: 3980,
        rating: 3.8,
        color: ["BLACK", "BLUE"],
        gender: "MALE",
    },
    {
        id: "789042",
        brandName: "HIGHLANDER",
        productName: "Slim Fit Printed Casual Shirt",
        price: 576,
        originalPrice: 1049,
        discountPercent: 45,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11780944/2020/4/3/1ee22980-624d-4822-8a7b-1934c2ade5ba1585905005496HIGHLANDERMenBlackWhiteSlimFitPrintedCasualShirt1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11780944/2020/4/3/c815eeeb-be3c-450d-84d9-387d77d8642c1585905005561HIGHLANDERMenBlackWhiteSlimFitPrintedCasualShirt2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11780944/2020/4/3/b716a293-d3e1-452c-889a-ed3aa7463c391585905005634HIGHLANDERMenBlackWhiteSlimFitPrintedCasualShirt3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11780944/2020/4/3/c8bb60df-3cfd-4193-b0a8-7802c0ce53ae1585905005704HIGHLANDERMenBlackWhiteSlimFitPrintedCasualShirt4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11780944/2020/4/3/d04f8a69-8cb8-4132-a55e-c03fb1602a921585905005771HIGHLANDERMenBlackWhiteSlimFitPrintedCasualShirt5.jpg",
        ],
        postedAt: 1575221421,
        numberOfReviews: 77,
        rating: 3.5,
        color: ["BLACK", "WHITE"],
        gender: "MALE",
    },
    {
        id: "510983",
        brandName: "MAST & HARBOUR",
        productName: "Slim Fit Solid Casual Shirt",
        price: 854,
        originalPrice: 1899,
        discountPercent: 55,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2389862/2018/4/19/11524137287746-Mast--Harbour-Men-Pink-Regular-Fit-Solid-Casual-Shirt-1991524137287562-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2389862/2018/4/19/11524137287732-Mast--Harbour-Men-Pink-Regular-Fit-Solid-Casual-Shirt-1991524137287562-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2389862/2018/4/19/11524137287710-Mast--Harbour-Men-Pink-Regular-Fit-Solid-Casual-Shirt-1991524137287562-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2389862/2018/4/19/11524137287684-Mast--Harbour-Men-Pink-Regular-Fit-Solid-Casual-Shirt-1991524137287562-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2389862/2018/4/19/11524137287663-Mast--Harbour-Men-Pink-Regular-Fit-Solid-Casual-Shirt-1991524137287562-5.jpg",
        ],
        postedAt: 1367346600,
        numberOfReviews: 144,
        rating: 4.2,
        color: ["PINK"],
        gender: "MALE",
    },
    {
        id: "567845",
        brandName: "GINI & JONY",
        productName: "Regular Fir Checked Shirt",
        price: 1049,
        originalPrice: 1399,
        discountPercent: 25,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11083618/2021/2/12/495ec6d7-4e48-4c67-9c2c-d109b67b573e1613121119602-Gini-and-Jony-Girls-Maroon--White-Regular-Fit-Checked-Casual-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11083618/2021/2/12/a957105b-debd-4f52-bef9-a15884e42c091613121119583-Gini-and-Jony-Girls-Maroon--White-Regular-Fit-Checked-Casual-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11083618/2021/2/12/79d9d478-e230-44b8-8e10-866f151f70a51613121119564-Gini-and-Jony-Girls-Maroon--White-Regular-Fit-Checked-Casual-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11083618/2021/2/12/5f0f0139-4007-4d29-9c01-2c211d9595a01613121119543-Gini-and-Jony-Girls-Maroon--White-Regular-Fit-Checked-Casual-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11083618/2021/2/12/7e4a1ae9-fa5f-4d89-83ae-d92da3d333f51613121119527-Gini-and-Jony-Girls-Maroon--White-Regular-Fit-Checked-Casual-5.jpg",
        ],
        postedAt: 1300628719,
        numberOfReviews: 50,
        rating: 4.0,
        color: ["MAROON", "WHITE"],
        gender: "GIRLS",
    },
    {
        id: "667788",
        brandName: "PEPE JEANS",
        productName: "Regular Fit Printed Casual Shirt",
        price: 549,
        originalPrice: 999,
        discountPercent: 45,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271624/2021/1/28/ed23bd79-40c6-467e-b516-316242d7fcde1611833536029PepeJeansGirlsLimeGreenRegularFitPrintedCasualShirt1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271624/2021/1/28/fd787204-2eb2-48cb-89cc-75253c861f1b1611833536070PepeJeansGirlsLimeGreenRegularFitPrintedCasualShirt2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271624/2021/1/28/557d1507-e314-4228-9179-1a5cf67617981611833536095PepeJeansGirlsLimeGreenRegularFitPrintedCasualShirt3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271624/2021/1/28/da7fa80e-0ceb-4eb0-aeea-c15c726c45f91611833536118PepeJeansGirlsLimeGreenRegularFitPrintedCasualShirt4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271624/2021/1/28/6a3b439a-d106-46b6-b099-b70dfd6aecf31611833536144PepeJeansGirlsLimeGreenRegularFitPrintedCasualShirt5.jpg",
        ],
        postedAt: 1262334919,
        numberOfReviews: 100,
        rating: 4.5,
        color: ["GREEEN"],
        gender: "GIRLS",
    },
    {
        id: "990077",
        brandName: "GAP",
        productName: "Faded Denim Casual Shirt",
        price: 1839,
        originalPrice: 2299,
        discountPercent: 20,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12810666/2021/2/8/87562077-aebf-4108-970e-937ba6879f771612786593723-GAP-Girls-Blue-Regular-Fit-Faded-Denim-Cotton-Casual-Shirt-1-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12810666/2021/2/8/db1b28e0-39ce-4272-ab85-b23639dac6ca1612786593700-GAP-Girls-Blue-Regular-Fit-Faded-Denim-Cotton-Casual-Shirt-1-2.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12810666/2021/2/8/b0a2876e-11e9-4dce-b44e-ca4140ee775c1612786593681-GAP-Girls-Blue-Regular-Fit-Faded-Denim-Cotton-Casual-Shirt-1-3.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12810666/2021/2/8/c04e6bcd-7ced-4249-aa34-6e2c986c21a71612786593662-GAP-Girls-Blue-Regular-Fit-Faded-Denim-Cotton-Casual-Shirt-1-4.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12810666/2021/2/8/3428b3aa-0054-41fa-90d5-90393cfa24ca1612786593643-GAP-Girls-Blue-Regular-Fit-Faded-Denim-Cotton-Casual-Shirt-1-5.jpg",
        ],
        postedAt: 1240356919,
        numberOfReviews: 150,
        rating: 4.9,
        color: ["BLUE"],
        gender: "GIRLS",
    },
    {
        id: "445599",
        brandName: "H & M",
        productName: "FaOversized Cotton Shirt",
        price: 1299,
        originalPrice: 1299,
        discountPercent: 0,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/17/804706d7-bf6d-42de-9eff-0faf4a67f10d1613577678101-1.jpg",

        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/17/4a25e187-c093-47b5-a2ea-6bd336c03f261613577678117-2.jpg",
        ],
        postedAt: 1201791021,
        numberOfReviews: 290,
        rating: 4.0,
        color: ["PURPLE"],
        gender: "GIRLS",
    },
    {
        id: "301095",
        brandName: "PEPE JEANS",
        productName: "Regular Fir Solid Denim Shirt",
        price: 959,
        originalPrice: 1599,
        discountPercent: 40,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271594/2021/1/28/5131ba41-11e2-4344-bc7b-31258f96af721611833535290PepeJeansGirlsBlueRegularFitSolidCasualDenimShirt1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271594/2021/1/28/43134f0d-4b37-4208-8e0b-b56c08392ec31611833535334PepeJeansGirlsBlueRegularFitSolidCasualDenimShirt2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271594/2021/1/28/d584e3ae-f16f-410a-8c61-9255a88bdf0a1611833535355PepeJeansGirlsBlueRegularFitSolidCasualDenimShirt3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/11271594/2021/1/28/391ba51a-1d2f-4b2c-bb57-a8d68fe841641611833535377PepeJeansGirlsBlueRegularFitSolidCasualDenimShirt4.jpg",
        ],
        postedAt: 1179365841,
        numberOfReviews: 50,
        rating: 4.1,
        color: ["BLUE"],
        gender: "GIRLS",
    },
    {
        id: "4001",
        brandName: "PANNKH",
        productName: "Navy Blue Printed Top",
        price: 549,
        originalPrice: 999,
        discountPercent: 45,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2506738/2018/7/18/df0c1d8c-528d-4afd-9714-a40c19b105ec1531903512284-Pannkh-Women-Navy-Blue-Printed-Top-6761531903512079-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2506738/2018/7/18/bd70e27a-21e3-4abc-bda7-f780296e493e1531903512255-Pannkh-Women-Navy-Blue-Printed-Top-6761531903512079-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2506738/2018/7/18/c0e43db5-8df9-492d-85dd-9775adcb9ac81531903512216-Pannkh-Women-Navy-Blue-Printed-Top-6761531903512079-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2506738/2018/7/18/9643a585-6d2c-4379-88d8-57777e0cf0321531903512192-Pannkh-Women-Navy-Blue-Printed-Top-6761531903512079-4.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/2506738/2018/7/18/49e1417a-8696-471a-b1e3-0ccbb47b917a1531903512159-Pannkh-Women-Navy-Blue-Printed-Top-6761531903512079-5.jpg",
        ],
        postedAt: 1483209000,
        numberOfReviews: 102,
        rating: 4.2,
        color: ["BLUE"],
        gender: "FEMALE",
    },
    {
        id: "4002",
        brandName: "SASSAFRAS",
        productName: "White Solid High-Neck Top",
        price: 649,
        originalPrice: 999,
        discountPercent: 35,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12221944/2020/8/14/b9fc8ee9-ec92-4557-ab60-000e3779291e1597404329638-SASSAFRAS-Women-White-Solid-Top-8171597404327851-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12221944/2020/8/17/5d6326be-82ef-4d4e-8c77-55eb7b28f4b01597641820677-SASSAFRAS-Women-White-Solid-Top-9391597641820541-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12221944/2020/8/14/48019537-1cf2-4fd5-ad61-9b9b399b4df71597404329532-SASSAFRAS-Women-White-Solid-Top-8171597404327851-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12221944/2020/8/14/9d5d7879-7a80-4b2b-b6e2-a4268fc3897f1597404329466-SASSAFRAS-Women-White-Solid-Top-8171597404327851-4.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12221944/2020/8/14/bef9b948-8555-40bc-b280-d85b8c06fdc21597404329403-SASSAFRAS-Women-White-Solid-Top-8171597404327851-5.jpg",
        ],
        postedAt: 1496255400,
        numberOfReviews: 519,
        rating: 3.7,
        color: ["WHITE"],
        gender: "FEMALE",
    },
    {
        id: "4003",
        brandName: "KASSUALLY",
        productName: "Black Solid Peplum Top",
        price: 597,
        originalPrice: 1299,
        discountPercent: 54,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/6/9/aae6d5da-cee2-4fdf-99cd-b5421d86d68a1591654989641-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/6/9/1c27dcfe-d135-4609-aa25-2d2df002e78d1591654989704-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/6/9/89b16512-6d1a-4892-b404-1e85fc4f791e1591654989757-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/6/9/e7b4d8be-f613-4686-ab49-0cbf6829b64a1591654989809-4.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/6/9/f939480f-bd06-4b5d-853d-a0aa8a4146931591654989867-5.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/6/9/9385aeda-976d-419a-a35a-6e8c302629f61591654989915-6.jpg",
        ],
        postedAt: 1527791400,
        numberOfReviews: 963,
        rating: 4.3,
        color: ["BLACK"],
        gender: "FEMALE",
    },
    {
        id: "4004",
        brandName: "HARPA",
        productName: "Peach Solid Empire Top",
        price: 584,
        originalPrice: 1299,
        discountPercent: 55,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/10/6/49df934c-237e-4681-97f9-21338fae580c1601936086956-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/10/6/42c9b193-4590-467b-8111-8f3aab0d11671601936087025-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/10/6/56faea02-4d6d-45a7-8ca6-8880f0c9c4f11601936087095-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/10/6/e47da943-c2dd-4583-a2b0-cb0730b0437c1601936087164-4.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/10/6/2b73e5d8-3d93-44b4-8cf7-26a8ff5ac7711601936087221-6.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/10/6/db9fa343-dd15-4441-8177-bcc1dbb5b9e51601936087293-7.jpg",
        ],
        postedAt: 1517423400,
        numberOfReviews: 41,
        rating: 3.4,
        color: ["PEACH"],
        gender: "FEMALE",
    },
    {
        id: "4005",
        brandName: "HERE&NOW",
        productName: "Women Printed Shirt Style",
        price: 599,
        originalPrice: 1199,
        discountPercent: 50,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/3084520/2018/4/13/11523621193965-HERENOW-Women-Tops-111523621193851-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/3084520/2018/4/13/11523621193950-HERENOW-Women-Tops-111523621193851-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/3084520/2018/4/13/11523621193938-HERENOW-Women-Tops-111523621193851-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/3084520/2018/4/13/11523621193982-HERENOW-Women-Tops-111523621193851-4.jpg",
        ],
        postedAt: 1533127578,
        numberOfReviews: 416,
        rating: 4.1,
        color: ["WHITE", "BLACK"],
        gender: "FEMALE",
    },
    {
        id: "4006",
        brandName: "WOOWZERZ",
        productName: "Women Burgundy Solid Top",
        price: 957,
        originalPrice: 1595,
        discountPercent: 40,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12052802/2020/8/7/4c9a1dd2-9be4-4223-b450-087c461f68f91596801825132-WoowZerz-Women-Burgundy-Solid-Peplum-Top-6311596801823505-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12052802/2020/8/7/76cab922-bfc6-465f-84d7-a79375951aee1596801825073-WoowZerz-Women-Burgundy-Solid-Peplum-Top-6311596801823505-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12052802/2020/8/7/f3ec153a-43d7-46ce-80a6-a1ec2b8c08af1596801824999-WoowZerz-Women-Burgundy-Solid-Peplum-Top-6311596801823505-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12052802/2020/8/7/034852c0-d75c-41ec-b81f-b3811ad4b35a1596801824925-WoowZerz-Women-Burgundy-Solid-Peplum-Top-6311596801823505-4.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12052802/2020/8/7/df5733c5-506b-4cec-8090-204dea28f3971596801824843-WoowZerz-Women-Burgundy-Solid-Peplum-Top-6311596801823505-5.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/12052802/2020/8/7/048fb376-135e-4710-ad24-a7d0a195ab781596801905395-WoowZerz-Women-Burgundy-Solid-Peplum-Top-9931596801905159-6.jpg",
        ],
        postedAt: 1543679178,
        numberOfReviews: 114,
        rating: 4.5,
        color: ["BURGUNDY"],
        gender: "FEMALE",
    },
    {
        id: "4007",
        brandName: "H&M",
        productName: "Women Black Striped Blouse",
        price: 1234,
        originalPrice: 1299,
        discountPercent: 5,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/1/15/cf97a00d-b7d8-4e43-af44-ba48620ec7061610698005949-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/1/15/d8fcb649-8a66-4e77-a2a4-52f102519c581610698005968-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/1/15/2c69a2ec-1098-4290-bc32-d3e0ce5a93651610698005986-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/1/15/985eac9a-7320-4991-b970-af4b1673e5c31610698006004-4.jpg",
        ],
        postedAt: 1546357578,
        numberOfReviews: 5,
        rating: 3.7,
        color: ["BLACK"],
        gender: "FEMALE",
    },
    {
        id: "4008",
        brandName: "MANGO",
        productName: "Teal Blue Solid Top",
        price: 4131,
        originalPrice: 4590,
        discountPercent: 10,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344610/2021/1/21/b97763f3-71bd-4cd0-b5c4-1b571dc230151611229133037-MANGO-Women-Teal-Blue-Solid-Top-With-Satin-Finish-4631611229-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344610/2021/1/21/731ba62e-5898-4c52-be20-1ed50ae14ec31611229133018-MANGO-Women-Teal-Blue-Solid-Top-With-Satin-Finish-4631611229-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344610/2021/1/21/cb0c9a0d-1640-4fcc-800f-3b8c456ebe971611229132992-MANGO-Women-Teal-Blue-Solid-Top-With-Satin-Finish-4631611229-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344610/2021/1/21/fd4522f6-4b42-46bc-b6c4-bac6903e65df1611229132975-MANGO-Women-Teal-Blue-Solid-Top-With-Satin-Finish-4631611229-4.jpg",
        ],
        postedAt: 1556725578,
        numberOfReviews: 219,
        rating: 4.7,
        color: ["BLUE"],
        gender: "FEMALE",
    },
    {
        id: "4009",
        brandName: "FOREVER NEW",
        productName: "Women White Floral Top",
        price: 4080,
        originalPrice: 4800,
        discountPercent: 15,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/10/89b85d31-7cb8-4240-bdea-73fbc39fbd071612960055361-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/10/9c77c476-ae24-4e8d-9ab6-a44cbf8b3f491612960055379-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/10/2dc44200-4e12-44b4-83a5-b2d274174a2b1612960055400-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/10/905a0ebc-2090-41fc-a461-930c048258861612960055419-4.jpg",
        ],
        postedAt: 1572558378,
        numberOfReviews: 19,
        rating: 3.9,
        color: ["WHITE"],
        gender: "FEMALE",
    },
    {
        id: "4010",
        brandName: "MANGO",
        productName: "Women Dusty Pink Top",
        price: 4131,
        originalPrice: 4590,
        discountPercent: 10,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344980/2021/1/21/ea56a063-b1cb-425a-a33a-71b6b942e9fc1611220605290-MANGO-Women-Dusty-Pink--Golden-Self-Design-Semi-Sheer-Tie-up-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344980/2021/1/21/4988ff45-d59b-4364-9ac7-75d966d7cf971611220605270-MANGO-Women-Dusty-Pink--Golden-Self-Design-Semi-Sheer-Tie-up-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344980/2021/1/21/7752f265-e4a6-42ae-80ec-8f99a73610911611220605248-MANGO-Women-Dusty-Pink--Golden-Self-Design-Semi-Sheer-Tie-up-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13344980/2021/1/21/b75e99d9-0719-41d7-b090-f629521fcadf1611220605228-MANGO-Women-Dusty-Pink--Golden-Self-Design-Semi-Sheer-Tie-up-4.jpg",
        ],
        postedAt: 1454276778,
        numberOfReviews: 65,
        rating: 4.9,
        color: ["PINK"],
        gender: "FEMALE",
    },
    {
        id: "5001",
        brandName: "Kids Clan",
        productName: "Regular Fit Solid Shirt",
        price: 489,
        originalPrice: 499,
        discountPercent: 2,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/8744065/2019/2/25/63ece92d-a54c-4d62-8a8b-f99b196c4cff1551090533837-Kids-Clan-Boys-Shirts-3861551090533549-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/8744065/2019/2/25/89fc13de-45f6-41c9-a909-d70f21f7c5321551090533824-Kids-Clan-Boys-Shirts-3861551090533549-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/8744065/2019/2/25/7d4e7d91-5612-440a-aec1-d98ab9d8cb361551090533812-Kids-Clan-Boys-Shirts-3861551090533549-3.jpg",
        ],
        postedAt: 1574164088,
        numberOfReviews: 14,
        rating: 3.6,
        color: ["WHITE", "BLACK"],
        gender: "BOYS",
    },

    {
        id: "5002",
        brandName: "max",
        productName: "Regular Fit Printed Shirt",
        price: 499,
        originalPrice: 499,
        discountPercent: 0,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/9/f5dec3ca-5b26-4a04-8130-ee115cdc1fc61612857822599-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/9/557d6e17-2d22-4c47-b4f3-ed66b3ba0cf21612857822617-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/9/87cfb6a5-8f50-482b-bc67-62153a94723b1612857822636-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/9/0bc1754a-22c6-4997-bf07-4237b0e111b81612857822658-4.jpg",
        ],
        postedAt: 1534667720,
        numberOfReviews: 19,
        rating: 4.1,
        color: ["BLUE"],
        gender: "BOYS",
    },

    {
        id: "5003",
        brandName: "Cherokee",
        productName: "Regular Printed Casual Shirt",
        price: 449,
        originalPrice: 499,
        discountPercent: 10,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/1/cf3d4271-222b-4410-ab48-4ea9af0e80e81612182366650-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/1/0cffd48a-fac3-4d0f-bf75-1d22f5d037b81612182366692-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2021/2/1/d27ac219-7251-4bf1-aba7-6c9b8f2be8f01612182366715-3.jpg",
        ],
        postedAt: 1518042920,
        numberOfReviews: 8,
        rating: 4.9,
        color: ["BLUE"],
        gender: "BOYS",
    },

    {
        id: "5004",
        brandName: "URBAN SCOTTISH",
        productName: "Regular Fit Printed Casual Shirt",
        price: 799,
        originalPrice: 1599,
        discountPercent: 50,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/11/7/1b2c3536-5412-4eee-9487-34dbfcfd506c1604742045020-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/11/7/4a99deaa-f4b0-4908-9615-738a0263da211604742045071-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/productimage/2020/11/7/154c3afc-9cbb-4db1-978e-d2dd4319a6ef1604742045115-3.jpg",
        ],
        postedAt: 1541086520,
        numberOfReviews: 39,
        rating: 3.9,
        color: ["RED"],
        gender: "BOYS",
    },

    {
        id: "5005",
        brandName: "Indian Terrain",
        productName: "Regular Fit Pure Cotton Solid Shirt",
        price: 719,
        originalPrice: 1199,
        discountPercent: 40,
        images: [
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13360366/2021/2/8/e143a2b0-9cc4-4cc1-8765-0c5b63e12ba61612760736412-Indian-Terrain-Boys-Green-Regular-Fit-Pure-Cotton-Solid-Casu-1.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13360366/2021/2/8/8463ff0b-a2bb-42a0-9825-cbc20443503a1612760736395-Indian-Terrain-Boys-Green-Regular-Fit-Pure-Cotton-Solid-Casu-2.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13360366/2021/2/8/97a0cf26-e734-45da-9993-6aa324c84c921612760736380-Indian-Terrain-Boys-Green-Regular-Fit-Pure-Cotton-Solid-Casu-3.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13360366/2021/2/8/b9396cee-f472-4556-a111-8b84d6c423211612760736360-Indian-Terrain-Boys-Green-Regular-Fit-Pure-Cotton-Solid-Casu-4.jpg",
        "https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/13360366/2021/2/8/fa7ddd56-b893-4448-b777-bc27b2c883521612760736344-Indian-Terrain-Boys-Green-Regular-Fit-Pure-Cotton-Solid-Casu-5.jpg",
        ],
        postedAt: 1465803860,
        numberOfReviews: 27,
        rating: 3.6,
        color: ["GREEN"],
        gender: "BOYS",
    },
];
